module.exports = __webpack_public_path__ + "static/media/daniel.fe64512a.jpg";